<template>
	<div
	v-if="clientName === 'sentaosa' && notPhone"
	id="sentaosa-app" >
		<div class="main-top">
			<img src="@/assets/leaf.png" class="leaf" >
			<img src="@/assets/sentaosa-logo.png" class="sentaosa-logo">
		</div>
		<div class="main-bottom">
			<p class="ml61">Download MySentosa App<br/>for more services</p>
			<div class="store-label">
				<img src="@/assets/store-label.png" class="label-img">
				<div class="label" @click="goWeb('app')"></div>
				<div class="label2" @click="goWeb('goole')"></div>
			</div>
			<img src="@/assets/fireworks.png" class="fire3">
		</div>
		<div class="main-container">
			<div class="scan-qr">
				<div class="qr">
					<img src="@/assets/sentaosa-qr.png" class="qrimg">
					<img src="@/assets/fireworks.png" class="fire2">
				</div>
				<img src="@/assets/arrow-up.svg" class="arrow">
				<p>Scan QR to enjoy better experience on mobile</p>
			</div>
			<div class="map-wrap">
				<img src="@/assets/fireworks.png" class="fire1">
				<img src="@/assets/people.png" class="people">
				<div class="map-outer">
					<div
					class="notPhone map-inner" 
					>
						<div class="nav-back" v-if="$route.meta.isBack" @click="routeBack">
							<img src="@/assets/nav-back.svg" >
						</div>
						<div class="route-view">
							<router-view />
						</div>
					</div>
					<!-- <div class="black-line"></div> -->
				</div>
			</div>
		</div>
	</div>
	<div
	v-else
	id="app" 
	:class="{'safari': safari, 'notPhone': notPhone}" 
	class="allCenter" 
	:style="{ 'max-width': webWidth + 'px' }">
	  <router-view />
	</div>
</template>

<script>
export default {
  computed: {
    safari () {
      return this.$store.state.safari
    },
    webWidth () {
      return this.$store.state.webWidth
    }
  },
  data () {
    return {
      notPhone: false,
			clientName: 'sentaosa', //圣淘沙
			// clientName: 'singapore' // 新加坡
			isUserAllowedGeoLocation: false,
			cantGetLocationErrorMessage: ''
    }
  },
  created () {
    let agent = window.navigator.userAgent
    // let systemMac = agent.indexOf("Mac OS")
    let systemPho = agent.indexOf("Pho")
    let systemAnd = agent.indexOf("And")
    if (systemPho > 0 || systemAnd > 0) {
      //移动端
      this.notPhone = false
      this.$store.commit('SET_WEBWIDTH', document.documentElement.clientWidth)
    } else {
      //pc端
	  if (this.clientName === 'sentaosa') {
		  if (document.documentElement.clientWidth >= 2540) {
			this.$store.commit('SET_WEBWIDTH', 635)
		  } else if (document.documentElement.clientWidth >= 1920) {
		  	this.$store.commit('SET_WEBWIDTH', 535)
		  }
	  } else {
		  this.$store.commit('SET_WEBWIDTH', 375)
	  }
      this.notPhone = true
    }
		this.$store.commit('SET_IS_SENTAOSA_WEB', this.clientName === 'sentaosa' && this.notPhone)
	},
  methods: {
	  goWeb(type) {
			const url = type === "app"
				? 'https://apps.apple.com/sg/app/mysentosa/id1671526843' 
				: 'https://play.google.com/store/apps/details?id=sg.com.sentosa.app.sentosaislander&pcampaignid=web_share'
		  window.open(url)
	  },
	  routeBack() {
		  this.$router.back()
		}
  }
}
</script>
<style lang="scss">
@import './map.css';
@import './global.scss';
@import  './sentaosa.scss';
</style>
